import {
    MyStoreStyled,
    SelectStoreButtonWrapper,
} from 'components/Blocks/Store/SelectStoreButton/SelectStoreButton.style';
import Button from 'components/Forms/Button/Button';
import useTranslation from 'next-translate/useTranslation';
import { SimpleCheckmarkIcon } from 'public/svg/IconsSvg';
import { useCallback, useState } from 'react';
import { usePersistStore } from 'store/usePersistStore';

type StoreBenefitsProps = {
    storeUuid: string;
};

const SelectStoreButton: FC<StoreBenefitsProps> = ({ storeUuid }) => {
    const { t } = useTranslation();
    const { updateDefaultStoreUuidState } = usePersistStore((s) => s);

    const { defaultStoreUuid } = usePersistStore((s) => s);
    const [isDefaultStore, setDefaultStore] = useState(storeUuid === defaultStoreUuid);

    const setDefaultStoreHandler = useCallback(
        (storeUuid: string | null) => () => {
            if (storeUuid === null) {
                setDefaultStore(false);
                updateDefaultStoreUuidState(null);

                return;
            }

            setDefaultStore(true);
            updateDefaultStoreUuidState(storeUuid);
        },
        [updateDefaultStoreUuidState],
    );

    if (isDefaultStore) {
        return (
            <SelectStoreButtonWrapper>
                <MyStoreStyled>
                    <SimpleCheckmarkIcon />
                    {t('My store')}
                </MyStoreStyled>
                <Button size="smallNarrow" type="button" onClick={setDefaultStoreHandler(null)}>
                    {t('Remove as my store')}
                </Button>
            </SelectStoreButtonWrapper>
        );
    }

    return (
        <SelectStoreButtonWrapper>
            <Button size="smallNarrow" type="button" onClick={setDefaultStoreHandler(storeUuid)}>
                {t('Set as my store')}
            </Button>
        </SelectStoreButtonWrapper>
    );
};

export default SelectStoreButton;
